import BaseUpdateRequest from "@/models/Shared/BaseUpdateRequest";

export default class UpdateWorkerQualificationRequest extends BaseUpdateRequest{
    status: number;
}